import { useEffect, forwardRef, useImperativeHandle } from "react";
var keys = {
    "9": "tab",
    "13": "enter",
};
function getValue(value) {
    return value.split("|").map(function (item) {
        return { name: item.trim() };
    });
}
export var PureInput = forwardRef(function Input(_a, ref) {
    var onChange = _a.onChange, inputValue = _a.inputValue, onSelect = _a.onSelect;
    useEffect(function () {
        // 编辑完成时 inputValue 被置空，此时 onChange 会导致标签键寻找失败
        if (inputValue.trim()) {
            onChange(getValue(inputValue));
        }
    }, [inputValue, onChange]);
    useImperativeHandle(ref, function () { return ({
        handleKeyDown: handleKeyDown,
    }); });
    function handleKeyDown(keyCode) {
        if (!keys[keyCode]) {
            return false;
        }
        switch (keys[keyCode]) {
            case "tab":
            case "enter":
                if (inputValue.length <= 0)
                    return false;
                if (onSelect) {
                    onSelect(getValue(inputValue).filter(function (i) { return !!i.name; }));
                }
                return false;
        }
        return false;
    }
    return null;
});
//# sourceMappingURL=PureInput.js.map